export default (a, b) => {
  if (!a && !b) {
    return true;
  } else if (!a || !b) {
    return false;
  }

  const equipmentMatch = (!a.equipment && !b.equipment) || (a.equipment && b.equipment && a.equipment.id === b.equipment.id);
  if (!equipmentMatch) {
    return false;
  }

  const aResourceIds = a.resources?a.resources.filter(r => !!r.resource).map(r => r.resource.id):[];
  const bResourceIds = b.resources?b.resources.filter(r => !!r.resource).map(r => r.resource.id):[];
  const resourcesMatch = aResourceIds.length === bResourceIds.length && aResourceIds.every((r) => bResourceIds.indexOf(r) >= 0);
  return resourcesMatch;
};
